import React, { useCallback, useEffect } from 'react';
import Layout from '../../components/layout/layout';
import * as actions from '../../actions';
// @ts-ignore
import { Loader } from 'arag-ui-lib';
import style from '../../components/layout/layout.module.scss';
import authentication from '../../utils/auth/react-azure-adb2c';
import InternalErrorsPage from '../../components/general/intermalErrorsPage/internalErrorsPage';
import useOnlineStatus from '../../hooks/useOnlineStatus';
import UnavailableWebAppPage from '../../components/general/unavailableWebAppPage/unavailableWebAppPage';
import { useAppSelector, useAppDispatch } from '../../hooks/hooks';
import { useIdleTimer } from 'react-idle-timer';

const LayoutContainer = () => {
    const dispatch = useAppDispatch();

    const apiApplicationSettings = useAppSelector(
        state => state.applicationSettings.apiApplicationSettings,
    );
    const accessToken = useAppSelector(
        state => state.applicationUser.accessToken,
    );
    const loading = useAppSelector(state => state.applicationUser.loading);
    const applicationUserDetails = useAppSelector(
        state => state.applicationUser.applicationUserDetails,
    );
    const serviceErrors = useAppSelector(state => state.message.serviceErrors);
    const internalErrors = useAppSelector(
        state => state.message.internalErrors,
    );
    const onlineStatus = useOnlineStatus();
    //after 30 minutes check if user is active or inactive
    useIdleTimer({
        timeout: 1800000,
        onIdle: () => authentication.checkTokenLogoutRedirection(),
    });

    const fetchApplicationSettingsAction = useCallback(
        (payload: actions.fetchApplicationSettingsAction) => {
            dispatch(actions.fetchApplicationSettings(payload as any));
        },
        [dispatch],
    );

    const fetchApplicationUserWordingsAction = useCallback(() => {
        dispatch(actions.fetchApplicationUserWordings());
    }, [dispatch]);

    const fetchApplicationCustomerFeedbackAction = useCallback(
        (payload: actions.fetchApplicationCustomerFeedbackAction) => {
            dispatch(actions.fetchApplicationCustomerFeedback(payload));
        },
        [dispatch],
    );

    useEffect(() => {
        fetchApplicationSettingsAction({});
    }, [fetchApplicationSettingsAction]);

    useEffect(() => {
        if (accessToken) {
            fetchApplicationCustomerFeedbackAction({});
            fetchApplicationUserWordingsAction();
        }
    }, [accessToken]);

    useEffect(() => {
        const interval = setInterval(() => {
            authentication.checkToRenewToken();
        }, 200000);
        return () => clearInterval(interval);
    }, []);

    if (loading && Object.keys(applicationUserDetails).length === 0) {
        return null;
    }

    if (internalErrors) {
        return <InternalErrorsPage />;
    }

    if (!onlineStatus?.onlineStatus || serviceErrors) {
        return <UnavailableWebAppPage errorImage={onlineStatus.offlineImage} />;
    }

    if (Object.keys(apiApplicationSettings).length === 0) {
        return (
            <div className={'container'}>
                <div className={`${style['content']} form-group`}>
                    <Loader />
                </div>
            </div>
        );
    }

    return <Layout />;
};

export default LayoutContainer;
